import { RadioField } from '@hologram-dimension/radio-field';
import ReleaseFlag from 'api/legacy/releaseFlags/enumReleaseFlags';
import useUserInfo from 'hooks/User/useUserInfo';
import { forwardRef } from 'react';
import { useForm } from 'react-hook-form';
import type { HologramSimIdsMap, OnSubmit } from 'types/common';
import BulkSendDataMessage from './BulkSendDataMessage';
import BulkSendSmsMessage from './BulkSendSmsMessage';
import styles from './SimInventoryBulkSendMessage.module.css';

interface SimInventoryBulkSendMessageProps {
  sims: HologramSimIdsMap;
  onProcessing: (value: boolean) => void;
  onDone: (sims?: Array<HologramSimId>) => void;
  onError: (error?: string) => void;
}

interface MessageMethodForm {
  method: 'sms' | 'cloudData';
}

const SimInventoryBulkSendMessage = forwardRef<OnSubmit, SimInventoryBulkSendMessageProps>(
  ({ sims, onProcessing, onDone, onError }, ref) => {
    const { register, watch } = useForm<MessageMethodForm>({
      mode: 'onChange',
      defaultValues: { method: 'sms' },
    });

    const method = watch('method');

    const { releaseFlags } = useUserInfo();

    const hasHologramCloudMessaging = releaseFlags.has(
      ReleaseFlag.FEATURE_HOLOGRAM_CLOUD_MESSAGING
    );

    const options = [{ label: 'SMS', value: 'sms' }];

    if (hasHologramCloudMessaging) {
      options.push({ label: 'Cloud data', value: 'cloudData' });
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.forms}>
          <RadioField label="Method" options={options} {...register('method')} />
          {method === 'sms' && (
            <BulkSendSmsMessage
              sims={sims}
              ref={ref}
              onProcessing={onProcessing}
              onDone={onDone}
              onError={onError}
            />
          )}
          {method === 'cloudData' && (
            <BulkSendDataMessage
              sims={sims}
              ref={ref}
              onProcessing={onProcessing}
              onDone={onDone}
              onError={onError}
            />
          )}
        </div>
      </div>
    );
  }
);

export default SimInventoryBulkSendMessage;
